module.exports = __webpack_public_path__ + "img/BatResidentielG.37d992cf.png";